import React from 'react';

import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';

import failImage from './assets/fail.png';

import dictionary from './Fail.dictionary.json';

import styles from './Fail.module.scss';

type FailProps = {
  onButtonClick: () => void;
};

export const Fail = ({ onButtonClick }: FailProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <img src={failImage}
           width={104}
           height={104} />
      <div className={styles.text}>
        <p className={styles.title}>{t(dictionary.title)}</p>
        <p className={styles.description}>{t(dictionary.description)}</p>
      </div>

      <Button type={ButtonType.BUTTON}
              intent={ButtonIntent.DEFAULT}
              onClick={onButtonClick}
              className={styles.footerCancelButton}
              data-ga-event="logInTelegramError">
        {t(dictionary.button)}
      </Button>
    </div>
  );
};
